<template>
  <UIForm id="facbookPixelEvents" class="w-100">
    <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
      <UIFormItem :label="t('common.onpageView')">
        <UISelect
          id="facebookEventsPageView"
          :value="store.facebook.pageViewEvent"
          :options="FB_EVENTS"
          @update:value="updateFacebookEventPageView"
        />
      </UIFormItem>
      <UIFormItem
        :label="
          product === PRODUCT_TYPE.SURVEY
            ? t('survey.onSurveySubmission')
            : product === PRODUCT_TYPE.QUIZ
            ? t('quiz.onQuizSubmission')
            : t('form.onFormSubmission')
        "
      >
        <UISelect
          id="facebokEventsSubmission"
          :value="store.facebook.formSubmissionEvent"
          :options="FB_EVENTS"
          @update:value="updateFacebookEventsSubmission"
        />
      </UIFormItem>
    </div>
  </UIForm>
</template>

<script setup lang="ts">
import { useAppStore } from "@/store/app";
import { FB_EVENTS, PRODUCT_TYPE } from "@/util/constants";
import { UIForm, UIFormItem, UISelect } from "@gohighlevel/ghl-ui";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const store = useAppStore();

defineProps({
  product: {
    type: String,
    default: PRODUCT_TYPE.FORM,
    required: true,
  },
});

const updateFacebookEventPageView = (value: string) => {
  store.facebook.pageViewEvent = value;
  store.anyUnsavedChanges = true;
  addToHistoryWithDelay();
};
const updateFacebookEventsSubmission = (value: string) => {
  store.facebook.formSubmissionEvent = value;
  store.anyUnsavedChanges = true;
  addToHistoryWithDelay();
};

const addToHistoryWithDelay = () => {
  setTimeout(() => store.addToHistory(), 100);
};
</script>
